// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"2ccab1e0","176":"3725f07b","212":"76487d39","221":"85cbc23e","339":"821c0921","352":"bc4273f0","515":"32792f8d","627":"e3d508ad","653":"9011233e","679":"d42ce63b","872":"08c87f23","958":"12f5c2e7"}[chunkId] + ".chunk.js";
};